// Base for every query
export const baseConfig = {
  staleTime: 5 * 60 * 1000, // 5 mins
  gcTime: 7 * 60 * 1000,    // 7 mins
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
}

// Check authentication
export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
}

// Query keys for all requests
export const queryKeys = {
  // Auth
  authProtected: ['auth', 'protected'],
  authUser: ['auth', 'user'],

  // Courses
  courses: ['courses'],
  course: (id) => ['course', id],
  coursesByType: (type, pageNumber, pageSize, showUnavailable = false) => [
    'courses',
    'type',
    type,
    pageNumber,
    pageSize,
    showUnavailable,
  ],
  coursesByTeacher: (teacherId) => ['courses', 'teacher', teacherId],
  coursesByTag: (tagId) => ['courses', 'tag', tagId],
  coursesByName: (courseName) => ['courses', 'courseName', courseName],
  coursesCount: (type) => type ? ['courses', 'count', type] : ['courses', 'count'],
  coursesForManagement: ['courses', 'forManagement'],
  
  // Tags
  tags: ['tags'],
  tag: (id) => ['tag', id],
  
  // Teachers
  teachers: ['teachers'],
  teacher: (id) => ['teacher', id],
  teachersByName: (name) => ['teachers', name],
  
  // Users
  users: ['users'],
  usersForCourse: (courseId) => ['users', courseId],
  usersWithEmail: (email) => ['users', email],
  
  // Programs, schedules, prices, etc.
  programs: ['programs'],
  schedules: ['schedules'],
  prices: ['prices'],
  benefits: ['benefits'],
  targetAudiences: ['targetAudiences'],
}

// Specific configurations for different types of data
export const queryConfigs = {
  auth: {
    ...baseConfig,
    staleTime: 2 * 60 * 1000, // Auth data updates more frequently
    retry: 0, // Don't retry auth queries
  },

  courses: {
    ...baseConfig,
    staleTime: 5 * 60 * 1000, // Courses are updated more often
  },
  tags: {
    ...baseConfig,
    staleTime: 30 * 60 * 1000, // Tags are updated rarely
  },
  teachers: {
    ...baseConfig,
    staleTime: 10 * 60 * 1000,
  },
  users: {
    ...baseConfig,
    staleTime: 15 * 60 * 1000,
  }
}

// Retry logic
export const retryConfig = (failureCount, error) => {
  // Do not retry for client errors
  if (error?.response?.status >= 400 && error?.response?.status < 500) {
    return false;
  }
  // Retry maximum 2 times for server errors
  return failureCount < 2;
}